import { render, staticRenderFns } from "./totalList.vue?vue&type=template&id=924b059a&scoped=true&"
import script from "./totalList.vue?vue&type=script&lang=js&"
export * from "./totalList.vue?vue&type=script&lang=js&"
import style0 from "./totalList.vue?vue&type=style&index=0&id=924b059a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "924b059a",
  null
  
)

export default component.exports